import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';


import { tyroPair } from '../../actions';


class TyroPairButton extends Component {
  constructor(props) {
    super(props);
    
    this._handleOnClick = this._handleOnClick.bind(this); 
  }

  _handleOnClick(event) {
    const { disabled, isPaired, merchantId, terminalId, tyroPair, onClick } = this.props;

    if (disabled) {
      return;
    }

    if (isPaired) {
      onClick(null);
      return;
    }

    tyroPair(merchantId, terminalId, onClick);
  }

  render() {
    const { isPaired = false, disabled = false } = this.props;
    return (
      <div 
        className={`ui ${isPaired ? 'negative' : 'positive'} ${disabled && 'disabled'} button`}
        onClick={this._handleOnClick}
      >
        {`${isPaired ? 'Unpair' : 'Pair'} to terminal`}
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    tyroPair
  }, dispatch);
}


TyroPairButton.propTypes = {
  merchantId: PropTypes.string.isRequired,
  terminalId: PropTypes.string.isRequired,
  isPaired: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}


export default connect(null, mapDispatchToProps)(TyroPairButton);